// +----------------------------------------------------------------------
// | 项目配置文件
// +----------------------------------------------------------------------
// | Copyright (c) 2018 安徽秒速科技有限公司 All rights reserved.
// +----------------------------------------------------------------------
// | Author：tangfei <957987132@qq.com>
// +----------------------------------------------------------------------
const app = {

  //是否开启ajax debug模式  true false
  ajax_debug:true,

  //是否开发者模式  true正式 false开发测试
  devMode: false,

  //是否使用jsonp true false
  jsonpMode:true,

  //图片域名
  imgSrc : "https://xhjg.oss-cn-beijing.aliyuncs.com/",

  //AJAX - API接口npm
  ajaxApi: {
      //正式测试用
      // hostName: "http://39.105.228.28:8086/xhjg-ssm-test/api",
      //测试用
      hostName:"http://39.105.228.28:8086/xhjg-ssm-test/api",
      //本地开发
      //  hostName: "http://localhost:8080/api",
    version : "",
    devHostName:'api'
  },

  //第三方接口
  thirdApi: {
    tz : "http://www.tscsmart.com/",
    ys : "https://open.ys7.com/api/",
      jx :"http://open.sennor.net:8085/device/"
  },

  //websocket配置
  websocket: {
    host: "ws://www.tscsmart.com/API/echo/", //地址
    protocols: [],
    options: {
      debug: true
    }
  },

  //vuescrollConfig虚拟滚动条 配置
  vuescrollConfig: {
    bar: {
      vBar: {
        background: "#c1c1c1"
      },
      hBar: {
        background: "#c1c1c1",
        opacity: 0
      }
    }
  }
};

export default app;
